import React from "react";
import { Link } from "react-router-dom";
import "../preview/Design13.css";

/* Catch-all 404. PageSEO sets <title>Page not found</title> + robots noindex for any
   unmatched route, so this only needs to render a friendly recovery UI. Self-contained
   styles keep it robust regardless of audience theming. */
export default function NotFound() {
  return (
    <main
      style={{
        minHeight: "78vh",
        display: "grid",
        placeItems: "center",
        padding: "96px 24px",
        textAlign: "center",
        background: "var(--ed-cream, #faf7f2)",
        color: "var(--ink, #1e2d38)",
      }}
    >
      <div style={{ maxWidth: 560 }}>
        <p
          style={{
            margin: 0,
            fontFamily: '"Geist Variable","Geist",system-ui,sans-serif',
            fontWeight: 700,
            fontSize: "clamp(3rem,10vw,5rem)",
            lineHeight: 1,
            letterSpacing: "-0.02em",
            color: "var(--logo-orange, #c45e20)",
          }}
        >
          404
        </p>
        <h1
          style={{
            margin: "14px 0 10px",
            fontFamily: '"Geist Variable","Geist",system-ui,sans-serif',
            fontWeight: 700,
            fontSize: "clamp(1.4rem,4vw,2rem)",
            letterSpacing: "-0.01em",
          }}
        >
          We couldn&rsquo;t find that page.
        </h1>
        <p style={{ margin: "0 0 28px", fontSize: "1rem", lineHeight: 1.6, color: "rgba(30,45,56,0.72)" }}>
          The link may be old or mistyped. Here&rsquo;s where most people go:
        </p>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
          <Link to="/" className="d13-btn d13-btn--primary">Home</Link>
          <Link to="/candidates" className="d13-btn d13-btn--outline">Find a job</Link>
          <Link to="/employers" className="d13-btn d13-btn--outline">Hire workers</Link>
        </div>
      </div>
    </main>
  );
}
